export default __webpack_public_path__ + "static/media/gameoflife_1.8589184f.png";